import React from 'react';
import { Container, Input, Header } from 'semantic-ui-react';

import SortByDistanceButton from './SortByDistanceButton';

export default class SearchLocations extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      searchHeader,
      searchHeaderAs,
      onSearchChange,
      searchQuery,
      searchPlaceholder,
      locationSortingStatus,
      onSort,
      distanceLoading,
    } = this.props;

    return (
      <Container className="fm-search-locations">
        <Header as={searchHeaderAs}>{searchHeader}</Header>
        <div>
          <Input
            fluid
            onChange={onSearchChange}
            value={searchQuery}
            action={{ content: 'Search', primary: true }}
            placeholder={searchPlaceholder}
          />
          <SortByDistanceButton
            locationSortingStatus={locationSortingStatus}
            onSort={onSort}
            loading={distanceLoading}
          />
        </div>
      </Container>
    );
  }
}
